/** @format */

export default {
    // ===== Register | Account =====

    // A couple of translations that appear in different steps on the Register and Account page.
    '.tn-interests .control-label': {},
    '.tn-interests .checkbox label': {},

    // Membership status when logged in
    '.tn-utility-nav-account-membership-status__name': {},
    // Membership overview
    '.tn-membership-summary__description': {},
    '.tn-membership-product__heading-level-description': {},
    // Items in the cart
    '.tn-cart-line-item-name': {},
    '.tn-cart-totals__label': {},
    // Production and package names
    '.tn-prod-list-item__property': {},

    // ===== Calendar =====

    // Filters above the calendar on the Events page.
    '#tn-events-keyword-filter li span': {},
};
